import { safeDecodeURIComponent } from './url';

/**
 * 解析文档中的所有 cookies，并将它们作为对象返回。
 * @returns {Record<string, string>} 一个对象，映射了 cookie 名称到它们的值。
 */
export const getAllCookies = (): Record<string, string> => {
    return document.cookie.split('; ').reduce((cookies, cookie) => {
        const [name, value] = cookie.split('=');

        cookies[name] = safeDecodeURIComponent(value || '');

        return cookies;
    }, {} as Record<string, string>);
};

/**
 * 通过名称检索特定的 cookie 值。
 * @param {string} key 要检索的 cookie 的名称。
 * @returns {string} cookie 的值，如果未找到则为空字符串。
 */
export const getCookie = (key: string): string => {
    const cookies = getAllCookies();

    return cookies[key] || '';
};

/**
 * 取主机名的可注册父域（最后两段标签）
 * 用于跨子域共享 cookie，例如 sofipo-app.didifinance.com -> didifinance.com
 * 注意：仅按最后两段取父域，适用于 didifinance.com 等单级 TLD；多级公共后缀（如 .co.uk）不在此范围。
 * @param hostname - location.hostname
 * @returns 父域字符串；单段主机名原样返回
 */
export const getParentDomain = (hostname: string): string => {
    const parts = hostname.split('.');
    if (parts.length <= 2) return hostname;
    return parts.slice(-2).join('.');
};
